<template>
    <flex-element :element-type="elementType" class="nav f-flex" :class="[directionClass, stateClasses]">
        <hamburger-button
            v-show="isMobile"
            class="nav__button"
            class-default="f-bg-gray-800 f-px-0.5 f-py-0.25"
            v-bind="element(3)"
            @element-updated="elementUpdated"
            @click.native="onMenuToggle"
        />

        <div
            class="nav__content f-flex f-flex-row f-flex-grow f-max-w-1/1 f-items-center"
            :class="bgColorClass"
            :style="transitionStyle"
        >
            <drop-zone-single v-bind="element(1)" @element-updated="elementUpdated" />

            <nav-dropdown
                v-for="(element, index) in ddElements"
                :key="element.id"
                v-bind="element"
                :index="index + staticElemCount"
                :pointer="index + (staticElemCount + 1)"
                :is-mobile="isMobile"
                @element-updated="elementUpdated"
            />

            <drop-zone-single v-bind="element(2)" @element-updated="elementUpdated" />
        </div>
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-dumb';
import { getClassDefinition } from '@/utils/tailwind-helper';
import { STATE_CLASSES } from '@/data/constants/classes';

const BREAKPOINT_ATTR_NAME = 'advanced-nav-breakpoint';
const SLIDE_DIRECTION_ATTR_NAME = 'hamburger-nav-slide-direction';
const SLIDE_SPEED_ATTR_NAME = 'hamburger-nav-slide-speed';

export default {
    name: 'nav-dropdown-collection-advanced',
    mixins: [baseOrganism],

    data() {
        return {
            isMobile: false,
            isCollapsed: true,
            staticElemCount: 3,
        };
    },

    computed: {
        bgColorClass() {
            return this.htmlClass.find((className) => {
                const classDefinition = getClassDefinition(className);
                const { tailwindDefinitionProp } = classDefinition;

                return tailwindDefinitionProp === 'backgroundColor';
            });
        },

        ddElements() {
            return this.elementsNew.slice(this.staticElemCount);
        },

        directionClass() {
            return `is-${ this.slideInDirection }`;
        },

        mobileModeBreakpoint() {
            return this.getElementData(BREAKPOINT_ATTR_NAME);
        },

        slideInDirection() {
            return this.getElementData(SLIDE_DIRECTION_ATTR_NAME);
        },

        slideInSpeed() {
            return this.getElementData(SLIDE_SPEED_ATTR_NAME);
        },

        stateClasses() {
            const classes = [];

            if (this.isMobile) classes.push(STATE_CLASSES.COMPACT);
            if (this.isCollapsed) classes.push(STATE_CLASSES.COLLAPSED);

            return classes;
        },

        transitionStyle() {
            return {
                transition: `all ${ this.slideInSpeed }s`,
            };
        },
    },

    mounted() {
        if (this.mobileModeBreakpoint) {
            window.addEventListener('resize', this.onResize);
            this.detectMobile();
        }
    },

    destroyed() {
        window.removeEventListener('resize', this.onResize);
    },

    methods: {
        onResize() {
            this.detectMobile();
        },

        onMenuToggle() {
            this.isCollapsed = !this.isCollapsed;
        },

        detectMobile() {
            const isMobile = window.innerWidth <= this.mobileModeBreakpoint;

            if (isMobile) {
                this.isMobile = true;
            } else {
                this.isMobile = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.nav {
    $this: &;

    &.#{ $is-compact } {
        align-items: start;
    }

    &.#{ $is-compact }.is-right {
        justify-content: flex-end;
    }

    &__button {
        display: none;
        position: absolute;
        top: 0.625rem;
        z-index: 10;

        #{ $this }.#{ $is-compact } & {
            display: block;
        }

        #{ $this }.#{ $is-compact }.is-left & {
            left: 0.625rem;
        }

        #{ $this }.#{ $is-compact }.is-right & {
            right: 0.625rem;
        }
    }

    &__content {
        position: relative;
        width: max-content;
        opacity: 1;
        left: 0;

        #{ $this }.#{ $is-compact } & {
            position: absolute;
            top: 100%;
            flex-direction: column;
            flex-grow: 1;
            width: 100%;
        }

        #{ $this }.#{ $is-compact }.#{ $is-collapsed }.is-left & {
            left: -100%;
            opacity: 0;
        }

        #{ $this }.#{ $is-compact }.#{ $is-collapsed }.is-right & {
            left: 100%;
            opacity: 0;
        }
    }
}
</style>
